import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const colorMap: Record<string, { bg: string; text: string; border: string; hover: string }> = {
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-700',
    border: 'border-accent-200/60',
    hover: 'hover:border-accent-400',
  },
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-700',
    border: 'border-primary-200/60',
    hover: 'hover:border-primary-400',
  },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-700',
    border: 'border-secondary-200/60',
    hover: 'hover:border-secondary-400',
  },
};

export default function HomeCategories() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            攻略分类导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            按主题浏览撸啊撸攻略，从英雄玩法到段位提升，找到你需要的每一个技巧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group block p-6 rounded-xl border ${colors.border} bg-background-50 ${colors.hover} transition-all duration-300 no-underline cursor-pointer`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${colors.bg} ${colors.text} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
                <div className="flex items-center gap-1 mt-4 text-sm text-primary-500 font-medium">
                  浏览文章
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform duration-200 inline-block"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}